import { View, StyleSheet } from 'react-native'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { useThemeColors } from '../../lib/useThemeColors'
import { legibleOn } from '../../lib/contrast'

// Medaglia di un badge: cerchio col colore del livello e l'icona della famiglia.
//   state 'earned' : colore pieno; 'locked' : spenta (si intravede cosa c'e' da ottenere); 'secret' : punto interrogativo
export default function BadgeMedal({ icon, color, size = 44, state = 'earned' }) {
  const tc = useThemeColors()
  const earned = state === 'earned'
  const tint = earned ? color : tc.textDim
  return (
    <View
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
      style={[
        s.ring,
        { width: size, height: size, borderRadius: size / 2, borderColor: earned ? color : tc.border, backgroundColor: earned ? color + '26' : tc.bgCard2 },
      ]}
    >
      <MaterialCommunityIcons
        name={state === 'secret' ? 'help' : (icon || 'medal')}
        size={Math.round(size * 0.52)}
        color={earned ? legibleOn(color, tc.bgCard, 3) : tint}
        style={!earned && state !== 'secret' ? { opacity: 0.6 } : undefined}
      />
    </View>
  )
}

const s = StyleSheet.create({
  ring: { borderWidth: 2.5, alignItems: 'center', justifyContent: 'center' },
})
